import request from "@/utils/request";

export function hotHotel() {
  return request({
    url: '/index/sell_hotel',
    headers: {
      isToken: true
    },
    method: 'post',
    timeout: 20000
  })
}

export function searchKeyword(data) {
  return request({
    url: '/index/search_keywords',
    headers: {
      isToken: false
    },
    method: 'post',
    timeout: 20000,
    data: data
  })
}

export function hotHotels(data) {
  return request({
    url: '/index/sell_hotel',
    headers: {
      isToken: false
    },
    method: 'post',
    timeout: 20000,
    data: data
  })
}

export function banner() {
  return request({
    url: '/index/carousel',
    headers: {
      isToken: false
    },
    method: 'post',
    timeout: 20000,
  })
}


export function city_list(data = {country_id: 48}) {
  return request({
    url: '/index/get_city',
    headers: {
      isToken: false
    },
    method: 'post',
    timeout: 20000,
    data: data
  })
}

export function nowCityHotel(data) {
  return request({
    url: '/index/hotel_lowest_price',
    headers: {
      isToken: false
    },
    method: 'post',
    timeout: 20000,
    data: data
  })
}



export function hotel_details(data) {
  return request({
    url: 'hotel_details/hotel_details',
    headers: {
      isToken: true
    },
    method: 'post',
    timeout: 20000,
    data: data
  })
}



export function order_list(data) {
  return request({
    url: 'price_confirm/get_order_list',
    headers: {
      isToken: true
    },
    method: 'post',
    timeout: 20000,
    data: data
  })
}


export function pc_search_keywords(data) {
  return request({
    url: 'index/pc_search_keywords',
    headers: {
      isToken: true
    },
    method: 'post',
    timeout: 20000,
    data: data
  })
}


export function createdOrder(data) {
  return request({
    url: '/price_confirm/pc_create_order',
    headers: {
      isToken: true
    },
    method: 'post',
    timeout: 20000,
    data: data
  })
}

// 预定房间

export function reservation_room(data) {
  return request({
    url: '/hotel_details/reservation_room',
    headers: {
      isToken: true
    },
    method: 'post',
    timeout: 20000,
    data: data
  })
}

// 订单状态查询
export function monitorOrderStatus(data) {
  return request({
    url: '/order/monitorOrderStatus',
    headers: {
      isToken: true
    },
    method: 'post',
    timeout: 20000,
    data: data
  })
}

// 立即支付
export function pay(data) {
  return request({
    url: '/price_confirm/pc_order_immediate_pay',
    headers: {
      isToken: true
    },
    method: 'post',
    timeout: 20000,
    data: data
  })
}
// 删除订单

export function del_order(data) {
  return request({
    url: '/price_confirm/del_order',
    headers: {
      isToken: true
    },
    method: 'post',
    timeout: 20000,
    data: data
  })
}

// 退款
export function refund_operate(data) {
  return request({
    url: '/price_confirm/refund_operate',
    headers: {
      isToken: true
    },
    method: 'post',
    timeout: 20000,
    data: data
  })
}

// 退款
export function getCity(data) {
  return request({
    url: '/index/address',
    headers: {
      isToken: true
    },
    method: 'post',
    timeout: 20000,
    data: data
  })
}

export function country() {
  return request({
    url: '/index/countryList',
    headers: {
      isToken: true
    },
    method: 'post',
    timeout: 20000,
  })
}

export function attachment(data) {
  return request({
    url: '/index/vicinityHotel',
    headers: {
      isToken: true
    },
    data: data,
    method: 'post',
    timeout: 20000,
  })
}

export function selfHotel() {
  return request({
    url: '/index/selfHotel',
    headers: {
      isToken: true
    },
    method: 'post',
    timeout: 20000,
  })
}
